import html2canvas from "html2canvas";

const EXPORT_WIDTH = 760;
const DARK = "#2d3035";
const MUTED = "#8a8f98";

const cargarImagen = (src) =>
  new Promise((resolve) => {
    const img = new window.Image();
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src;
  });

// html2canvas no soporta object-fit: contain y estira los logos. Fijamos un
// ancho/alto explícito que respete la proporción real dentro de la misma caja.
const ajustarLogos = (original, copia) => {
  const originales = original.querySelectorAll("img");
  copia.querySelectorAll("img").forEach((img, index) => {
    const ref = originales[index];
    if (!ref || !ref.naturalWidth || !ref.naturalHeight) return;
    const cajaW = ref.clientWidth || ref.naturalWidth;
    const cajaH = ref.clientHeight || ref.naturalHeight;
    const escala = Math.min(cajaW / ref.naturalWidth, cajaH / ref.naturalHeight);
    Object.assign(img.style, {
      width: `${Math.round(ref.naturalWidth * escala)}px`,
      height: `${Math.round(ref.naturalHeight * escala)}px`,
      maxWidth: "none",
      maxHeight: "none",
      objectFit: "fill",
      margin: "0 auto",
    });
    img.removeAttribute("loading");
  });
};

const crearEncabezado = (logo, titulo, subtitulo) => {
  const header = document.createElement("div");
  Object.assign(header.style, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    paddingBottom: "18px",
    marginBottom: "18px",
    borderBottom: "1px solid #e6e8eb",
  });

  if (logo) {
    const alto = 30;
    const img = document.createElement("img");
    img.src = logo.src;
    Object.assign(img.style, {
      height: `${alto}px`,
      width: `${Math.round((logo.naturalWidth / logo.naturalHeight) * alto)}px`,
      display: "block",
    });
    header.appendChild(img);
  }

  const textos = document.createElement("div");
  textos.style.textAlign = "right";
  const h = document.createElement("div");
  h.textContent = titulo;
  Object.assign(h.style, { color: DARK, fontSize: "18px", fontWeight: "700", lineHeight: "1.2" });
  const s = document.createElement("div");
  s.textContent = subtitulo;
  Object.assign(s.style, { color: MUTED, fontSize: "12px", marginTop: "4px" });
  textos.append(h, s);
  header.appendChild(textos);
  return header;
};

const crearPie = (texto) => {
  const pie = document.createElement("div");
  pie.textContent = texto;
  Object.assign(pie.style, {
    marginTop: "16px",
    color: MUTED,
    fontSize: "11px",
    textAlign: "center",
  });
  return pie;
};

// Genera un PNG "listo para compartir" de un panel del comparador: ancho fijo,
// encabezado con la marca y pie con la aclaración. No modifica la pantalla.
export const exportarPanelComoImagen = async ({ elemento, logoSrc, titulo, subtitulo, pie, filename }) => {
  const logo = logoSrc ? await cargarImagen(logoSrc) : null;

  const contenedor = document.createElement("div");
  Object.assign(contenedor.style, {
    position: "fixed",
    left: "-10000px",
    top: "0",
    width: `${EXPORT_WIDTH}px`,
    padding: "32px",
    boxSizing: "border-box",
    background: "#ffffff",
  });

  const copia = elemento.cloneNode(true);
  Object.assign(copia.style, { boxShadow: "none", border: "0", padding: "0", width: "100%" });
  ajustarLogos(elemento, copia);

  contenedor.append(crearEncabezado(logo, titulo, subtitulo), copia, crearPie(pie));
  document.body.appendChild(contenedor);

  try {
    const canvas = await html2canvas(contenedor, { backgroundColor: "#ffffff", scale: 2, useCORS: true });
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    contenedor.remove();
  }
};
